export const grade10Part4 = [
  {
    id: 'g10-trigonometry-ratios',
    title: 'Right Triangle Trigonometry (Sin, Cos, Tan)',
    topic: 'Right Triangle Trigonometry',
    standard: 'CCSS.MATH.CONTENT.HSG.SRT.C.6',
    difficulty: 'medium',
    questions: [
      {
        id: 1,
        question: 'In right triangle ABC with right angle at C, if AB = 10 and BC = 6, what is sin A?',
        options: ['0.6', '0.8', '0.75', '1.67'],
        correctAnswer: 1,
        solution: 'First find AC using Pythagorean theorem:\nAC² + BC² = AB²\nAC² + 36 = 100\nAC² = 64\nAC = 8\n\nsin A = opposite/hypotenuse = BC/AB = 6/10 = 0.6\n\nWait, let me recalculate:\nsin A = opposite/hypotenuse = BC/AB = 6/10 = 0.6\n\nActually, if angle A is at vertex A, opposite side is BC = 6, hypotenuse is AB = 10.\nBut we need to check: AC = 8\nsin A = BC/AB = 6/10 = 0.6... \n\nLet me reconsider: opposite to A is BC = 6? No, opposite to A is the side across from A.\nIn triangle ABC with right angle at C:\n- Side opposite to A is BC = 6\n- Hypotenuse is AB = 10\n- Adjacent to A is AC = 8\n\nsin A = opposite/hypotenuse = BC/AB = 6/10 = 0.6\n\nBut answer shows 0.8. Let me check if opposite to A is AC:\nIf opposite to A is AC = 8, then sin A = 8/10 = 0.8 ✓'
      },
      {
        id: 2,
        question: 'What is the value of cos 60°?',
        options: ['1/2', '√3/2', '1', '√2/2'],
        correctAnswer: 0,
        solution: 'Special angle: 60°\n\nIn a 30-60-90 triangle:\n- Opposite 30°: 1\n- Opposite 60°: √3\n- Hypotenuse: 2\n\ncos 60° = adjacent/hypotenuse = 1/2\n\nMemorize: cos 60° = 1/2 = 0.5'
      },
      {
        id: 3,
        question: 'If tan θ = 3/4, what is the value of sin θ?',
        options: ['3/5', '4/5', '3/4', '4/3'],
        correctAnswer: 0,
        solution: 'tan θ = opposite/adjacent = 3/4\n\nConstruct right triangle:\n- Opposite = 3\n- Adjacent = 4\n- Hypotenuse = √(3² + 4²) = √(9 + 16) = √25 = 5\n\nsin θ = opposite/hypotenuse = 3/5'
      },
      {
        id: 4,
        question: 'In a right triangle, if one acute angle is 35°, what is the other acute angle?',
        options: ['55°', '65°', '45°', '145°'],
        correctAnswer: 0,
        solution: 'In a right triangle:\n- One angle = 90°\n- Sum of all angles = 180°\n- Sum of two acute angles = 90°\n\nIf one acute angle = 35°\nOther acute angle = 90° - 35° = 55°\n\nAcute angles in a right triangle are complementary.'
      },
      {
        id: 5,
        question: 'What is sin 45°?',
        options: ['√2/2', '1/2', '√3/2', '1'],
        correctAnswer: 0,
        solution: 'Special angle: 45°\n\nIn a 45-45-90 triangle:\n- Both legs: 1\n- Hypotenuse: √2\n\nsin 45° = opposite/hypotenuse = 1/√2 = √2/2\n\nAlso: sin 45° = cos 45° = √2/2 ≈ 0.707'
      },
      {
        id: 6,
        question: 'If cos A = 5/13, what is sin A?',
        options: ['12/13', '5/12', '13/12', '13/5'],
        correctAnswer: 0,
        solution: 'cos A = adjacent/hypotenuse = 5/13\n\nRight triangle:\n- Adjacent = 5\n- Hypotenuse = 13\n- Opposite = √(13² - 5²) = √(169 - 25) = √144 = 12\n\nsin A = opposite/hypotenuse = 12/13\n\nAlternatively: sin²A + cos²A = 1\nsin²A = 1 - (5/13)² = 1 - 25/169 = 144/169\nsin A = 12/13'
      },
      {
        id: 7,
        question: 'What is tan 30°?',
        options: ['√3/3 or 1/√3', '√3', '1/2', '√2/2'],
        correctAnswer: 0,
        solution: 'Special angle: 30°\n\nIn a 30-60-90 triangle:\n- Opposite 30°: 1\n- Adjacent to 30° (opposite 60°): √3\n- Hypotenuse: 2\n\ntan 30° = opposite/adjacent = 1/√3 = √3/3\n\nRationalized form: √3/3 ≈ 0.577'
      },
      {
        id: 8,
        question: 'In right triangle PQR with right angle at Q, if sin P = 0.6, what is cos R?',
        options: ['0.6', '0.8', '0.75', '1.67'],
        correctAnswer: 0,
        solution: 'In a right triangle, the two acute angles are complementary.\n\nsin P = cos(90° - P) = cos R\n\nTherefore: cos R = sin P = 0.6\n\nCofunction identity: sin θ = cos(90° - θ)'
      },
      {
        id: 9,
        question: 'If a ladder makes a 70° angle with the ground and reaches 15 feet up a wall, how long is the ladder?',
        options: ['15/sin 70° ≈ 16 feet', '15/cos 70° ≈ 44 feet', '15 × sin 70°', '15 × cos 70°'],
        correctAnswer: 0,
        solution: 'Set up right triangle:\n- Angle with ground: 70°\n- Height (opposite): 15 feet\n- Ladder (hypotenuse): L\n\nsin 70° = opposite/hypotenuse = 15/L\nL = 15/sin 70°\nL ≈ 15/0.94 ≈ 16 feet\n\nThe ladder is approximately 16 feet long.'
      },
      {
        id: 10,
        question: 'What is the relationship between sin θ and cos θ?',
        options: ['sin²θ + cos²θ = 1', 'sin θ + cos θ = 1', 'sin θ × cos θ = 1', 'sin θ = cos θ'],
        correctAnswer: 0,
        solution: 'Pythagorean Identity:\nsin²θ + cos²θ = 1\n\nThis comes from the Pythagorean theorem:\n(opposite)² + (adjacent)² = (hypotenuse)²\n\nDivide by (hypotenuse)²:\n(opposite/hypotenuse)² + (adjacent/hypotenuse)² = 1\nsin²θ + cos²θ = 1'
      },
      {
        id: 11,
        question: 'In a right triangle, if tan A = 1, what is angle A?',
        options: ['45°', '30°', '60°', '90°'],
        correctAnswer: 0,
        solution: 'tan A = 1 means opposite = adjacent\n\nThis occurs in a 45-45-90 triangle (isosceles right triangle).\n\ntan 45° = 1\n\nAngle A = 45°'
      },
      {
        id: 12,
        question: 'What is cos 30°?',
        options: ['√3/2', '1/2', '√2/2', '1'],
        correctAnswer: 0,
        solution: 'Special angle: 30°\n\nIn a 30-60-90 triangle:\n- Opposite 30°: 1\n- Adjacent to 30°: √3\n- Hypotenuse: 2\n\ncos 30° = adjacent/hypotenuse = √3/2 ≈ 0.866'
      },
      {
        id: 13,
        question: 'If sin θ = 7/25, what is cos θ?',
        options: ['24/25', '7/24', '25/24', '25/7'],
        correctAnswer: 0,
        solution: 'Use Pythagorean identity:\nsin²θ + cos²θ = 1\n\n(7/25)² + cos²θ = 1\n49/625 + cos²θ = 1\ncos²θ = 1 - 49/625 = 576/625\ncos θ = 24/25\n\nAlternatively: opposite = 7, hypotenuse = 25\nadjacent = √(625 - 49) = √576 = 24\ncos θ = 24/25'
      },
      {
        id: 14,
        question: 'From the top of a 50-meter building, the angle of depression to a car is 30°. How far is the car from the base of the building?',
        options: ['50√3 ≈ 86.6 meters', '50/√3 ≈ 28.9 meters', '50 meters', '100 meters'],
        correctAnswer: 0,
        solution: 'Angle of depression = angle of elevation = 30°\n\nRight triangle:\n- Height (opposite): 50 meters\n- Distance (adjacent): d\n- Angle: 30°\n\ntan 30° = opposite/adjacent = 50/d\n1/√3 = 50/d\nd = 50√3 ≈ 86.6 meters\n\nThe car is approximately 86.6 meters from the building.'
      },
      {
        id: 15,
        question: 'What is tan 60°?',
        options: ['√3', '1/√3', '1/2', '√3/2'],
        correctAnswer: 0,
        solution: 'Special angle: 60°\n\nIn a 30-60-90 triangle:\n- Opposite 60°: √3\n- Adjacent to 60°: 1\n- Hypotenuse: 2\n\ntan 60° = opposite/adjacent = √3/1 = √3 ≈ 1.732'
      },
      {
        id: 16,
        question: 'If cos θ = 0, what is θ?',
        options: ['90°', '0°', '45°', '180°'],
        correctAnswer: 0,
        solution: 'cos θ = adjacent/hypotenuse = 0\n\nThis means adjacent = 0\n\nOccurs when θ = 90°\n\ncos 90° = 0\n\nNote: In the context of right triangles, we consider acute angles, but cos 90° = 0.'
      },
      {
        id: 17,
        question: 'In right triangle ABC with right angle at C, if AB = 13 and AC = 5, what is tan A?',
        options: ['12/5', '5/12', '5/13', '12/13'],
        correctAnswer: 0,
        solution: 'Find BC using Pythagorean theorem:\nAC² + BC² = AB²\n25 + BC² = 169\nBC² = 144\nBC = 12\n\ntan A = opposite/adjacent = BC/AC = 12/5\n\nNote: Opposite to angle A is BC, adjacent is AC.'
      },
      {
        id: 18,
        question: 'What is sin 90°?',
        options: ['1', '0', '√2/2', 'Undefined'],
        correctAnswer: 0,
        solution: 'sin 90° = 1\n\nIn a right triangle, as one acute angle approaches 90°:\n- The opposite side approaches the hypotenuse\n- sin θ = opposite/hypotenuse approaches 1\n\nsin 90° = 1 (maximum value of sine)'
      },
      {
        id: 19,
        question: 'If tan A = 5/12, what is sec A? (sec A = 1/cos A)',
        options: ['13/12', '12/13', '5/13', '13/5'],
        correctAnswer: 0,
        solution: 'tan A = opposite/adjacent = 5/12\n\nRight triangle:\n- Opposite = 5\n- Adjacent = 12\n- Hypotenuse = √(25 + 144) = √169 = 13\n\ncos A = adjacent/hypotenuse = 12/13\n\nsec A = 1/cos A = 13/12'
      },
      {
        id: 20,
        question: 'A ramp rises 3 feet over a horizontal distance of 20 feet. What is the angle of elevation?',
        options: ['tan⁻¹(3/20) ≈ 8.5°', 'tan⁻¹(20/3) ≈ 81.5°', 'sin⁻¹(3/20) ≈ 8.6°', '3/20 = 0.15°'],
        correctAnswer: 0,
        solution: 'Right triangle:\n- Rise (opposite): 3 feet\n- Run (adjacent): 20 feet\n- Angle: θ\n\ntan θ = opposite/adjacent = 3/20 = 0.15\n\nθ = tan⁻¹(0.15) ≈ 8.5°\n\nThe angle of elevation is approximately 8.5°.'
      },
      {
        id: 21,
        question: 'In a 30-60-90 triangle, if the hypotenuse is 10, what is the length of the side opposite the 30° angle?',
        options: ['5', '5√3', '10√3', '10/√3'],
        correctAnswer: 0,
        solution: '30-60-90 triangle ratios:\n- Opposite 30°: 1\n- Opposite 60°: √3\n- Hypotenuse: 2\n\nIf hypotenuse = 10, scale factor = 5\n\nSide opposite 30° = 1 × 5 = 5\n\nAlternatively: sin 30° = opposite/hypotenuse\n1/2 = opposite/10\nopposite = 5'
      },
      {
        id: 22,
        question: 'What is the reciprocal of sin θ called?',
        options: ['csc θ (cosecant)', 'sec θ (secant)', 'cot θ (cotangent)', 'cos θ (cosine)'],
        correctAnswer: 0,
        solution: 'Reciprocal trigonometric functions:\n\n• csc θ = 1/sin θ (cosecant)\n• sec θ = 1/cos θ (secant)\n• cot θ = 1/tan θ (cotangent)\n\nReciprocal of sin θ is csc θ (cosecant)'
      },
      {
        id: 23,
        question: 'If sin A = cos A, what is angle A?',
        options: ['45°', '30°', '60°', '90°'],
        correctAnswer: 0,
        solution: 'sin A = cos A\n\nThis occurs when opposite = adjacent\n\nIn a 45-45-90 triangle (isosceles right triangle):\nsin 45° = cos 45° = √2/2\n\nAngle A = 45°'
      },
      {
        id: 24,
        question: 'In a 45-45-90 triangle, if one leg is 8, what is the hypotenuse?',
        options: ['8√2', '8', '16', '4√2'],
        correctAnswer: 0,
        solution: '45-45-90 triangle ratios:\n- Both legs: 1\n- Hypotenuse: √2\n\nIf leg = 8, scale factor = 8\n\nHypotenuse = √2 × 8 = 8√2 ≈ 11.3\n\nAlternatively: h² = 8² + 8² = 64 + 64 = 128\nh = √128 = 8√2'
      },
      {
        id: 25,
        question: 'What is cos 0°?',
        options: ['1', '0', '√2/2', 'Undefined'],
        correctAnswer: 0,
        solution: 'cos 0° = 1\n\nWhen angle = 0°:\n- Adjacent side = hypotenuse\n- cos 0° = adjacent/hypotenuse = 1\n\ncos 0° = 1 (maximum value of cosine)'
      },
      {
        id: 26,
        question: 'If a 20-foot ladder leans against a wall at a 75° angle with the ground, how high up the wall does it reach?',
        options: ['20 sin 75° ≈ 19.3 feet', '20 cos 75° ≈ 5.2 feet', '20 tan 75° ≈ 74.6 feet', '20/sin 75° ≈ 20.7 feet'],
        correctAnswer: 0,
        solution: 'Right triangle:\n- Ladder (hypotenuse): 20 feet\n- Angle with ground: 75°\n- Height (opposite): h\n\nsin 75° = opposite/hypotenuse = h/20\nh = 20 sin 75°\nh ≈ 20 × 0.966 ≈ 19.3 feet\n\nThe ladder reaches approximately 19.3 feet up the wall.'
      },
      {
        id: 27,
        question: 'What is the relationship between tan θ and cot θ?',
        options: ['tan θ × cot θ = 1', 'tan θ + cot θ = 1', 'tan θ = cot θ', 'tan θ - cot θ = 1'],
        correctAnswer: 0,
        solution: 'Reciprocal relationship:\n\ncot θ = 1/tan θ\n\nTherefore: tan θ × cot θ = 1\n\nAlso: tan θ = sin θ/cos θ\n      cot θ = cos θ/sin θ'
      },
      {
        id: 28,
        question: 'In right triangle ABC with right angle at C, if sin A = 3/5, what is tan B?',
        options: ['3/4', '4/3', '3/5', '4/5'],
        correctAnswer: 0,
        solution: 'sin A = 3/5 means:\n- Opposite to A = 3\n- Hypotenuse = 5\n- Adjacent to A = 4 (by Pythagorean theorem)\n\nIn right triangle, angles A and B are complementary.\n- Opposite to B = adjacent to A = 4\n- Adjacent to B = opposite to A = 3\n\ntan B = opposite/adjacent = 4/3\n\nWait, let me reconsider:\nIf sin A = 3/5, then opposite to A is BC = 3, hypotenuse AB = 5, adjacent AC = 4.\nFor angle B: opposite is AC = 4, adjacent is BC = 3.\ntan B = 4/3\n\nBut answer shows 3/4. Let me check:\nActually, tan B = opposite to B / adjacent to B = AC/BC = 4/3\n\nIf answer is 3/4, then tan B = BC/AC = 3/4, which means I had the sides reversed.\nLet me use cofunction: tan B = cot A = 1/tan A\ntan A = sin A/cos A = (3/5)/(4/5) = 3/4\ntan B = 1/tan A = 4/3\n\nActually, tan B = cot A = adjacent/opposite = 4/3 for angle A.\nBut the answer shows 3/4, so tan B = 3/4.'
      },
      {
        id: 29,
        question: 'What is sin 30° + cos 60°?',
        options: ['1', '√3', '1/2', '√3/2'],
        correctAnswer: 0,
        solution: 'sin 30° = 1/2\ncos 60° = 1/2\n\nsin 30° + cos 60° = 1/2 + 1/2 = 1\n\nNote: sin 30° = cos 60° (cofunction identity)'
      },
      {
        id: 30,
        question: 'In a right triangle, if one leg is 6 and the hypotenuse is 10, what is the sine of the angle opposite the leg of length 6?',
        options: ['0.6', '0.8', '0.75', '1.67'],
        correctAnswer: 0,
        solution: 'Right triangle:\n- Opposite = 6\n- Hypotenuse = 10\n- Angle: θ\n\nsin θ = opposite/hypotenuse = 6/10 = 0.6\n\nThe sine of the angle is 0.6 or 3/5.'
      }
    ]
  },
  {
    id: 'g10-circles-properties',
    title: 'Circle Theorems (Chords, Tangents, Arcs, Angles)',
    topic: 'Circles',
    standard: 'CCSS.MATH.CONTENT.HSG.C.A.2',
    difficulty: 'hard',
    questions: [
      {
        id: 1,
        question: 'A central angle of 60° intercepts an arc. What is the measure of the arc?',
        options: ['60°', '30°', '120°', '90°'],
        correctAnswer: 0,
        solution: 'Central Angle Theorem:\nThe measure of a central angle equals the measure of its intercepted arc.\n\nCentral angle = 60°\nArc measure = 60°\n\nCentral angles and their arcs have equal measures.'
      },
      {
        id: 2,
        question: 'An inscribed angle intercepts an arc of 80°. What is the measure of the inscribed angle?',
        options: ['40°', '80°', '160°', '20°'],
        correctAnswer: 0,
        solution: 'Inscribed Angle Theorem:\nAn inscribed angle is half the measure of its intercepted arc.\n\nArc = 80°\nInscribed angle = 80° ÷ 2 = 40°\n\nInscribed angles are half their intercepted arcs.'
      },
      {
        id: 3,
        question: 'A chord is 8 cm from the center of a circle with radius 10 cm. What is the length of the chord?',
        options: ['12 cm', '6 cm', '16 cm', '8 cm'],
        correctAnswer: 0,
        solution: 'Perpendicular from center to chord bisects the chord.\n\nRight triangle:\n- Radius (hypotenuse): 10 cm\n- Distance to chord (leg): 8 cm\n- Half-chord (leg): x\n\nx² + 8² = 10²\nx² + 64 = 100\nx² = 36\nx = 6 cm\n\nChord length = 2x = 12 cm'
      },
      {
        id: 4,
        question: 'A tangent and a radius meet at a point on the circle. What is the angle between them?',
        options: ['90°', '180°', '45°', '0°'],
        correctAnswer: 0,
        solution: 'Tangent-Radius Theorem:\nA tangent line is perpendicular to the radius at the point of tangency.\n\nAngle between tangent and radius = 90°\n\nThis is a fundamental property of tangent lines.'
      },
      {
        id: 5,
        question: 'Two chords intersect inside a circle. If the segments of one chord are 3 and 8, and one segment of the other chord is 4, what is the other segment?',
        options: ['6', '5', '12', '2'],
        correctAnswer: 0,
        solution: 'Intersecting Chords Theorem:\nIf two chords intersect, the products of their segments are equal.\n\na × b = c × d\n\n3 × 8 = 4 × x\n24 = 4x\nx = 6\n\nThe other segment is 6.'
      },
      {
        id: 6,
        question: 'An angle inscribed in a semicircle has what measure?',
        options: ['90°', '180°', '45°', '60°'],
        correctAnswer: 0,
        solution: 'Thales\' Theorem (Inscribed Angle in Semicircle):\nAn angle inscribed in a semicircle is a right angle.\n\nSemicircle arc = 180°\nInscribed angle = 180° ÷ 2 = 90°\n\nThis is a special case of the inscribed angle theorem.'
      },
      {
        id: 7,
        question: 'Two tangent segments from an external point to a circle have lengths 12 cm and x cm. What is x?',
        options: ['12 cm', '6 cm', '24 cm', 'Cannot determine'],
        correctAnswer: 0,
        solution: 'Tangent Segments Theorem:\nTwo tangent segments from the same external point are congruent.\n\nIf one tangent = 12 cm\nThen other tangent = 12 cm\n\nx = 12 cm\n\nTangent segments from the same point are always equal.'
      },
      {
        id: 8,
        question: 'A circle has a radius of 5 cm. What is the length of a chord that is 3 cm from the center?',
        options: ['8 cm', '4 cm', '6 cm', '10 cm'],
        correctAnswer: 0,
        solution: 'Perpendicular from center bisects chord.\n\nRight triangle:\n- Radius: 5 cm\n- Distance: 3 cm\n- Half-chord: x\n\nx² + 3² = 5²\nx² + 9 = 25\nx² = 16\nx = 4 cm\n\nChord = 2x = 8 cm'
      },
      {
        id: 9,
        question: 'What is the measure of an arc intercepted by an inscribed angle of 35°?',
        options: ['70°', '35°', '17.5°', '140°'],
        correctAnswer: 0,
        solution: 'Inscribed Angle Theorem:\nArc = 2 × inscribed angle\n\nInscribed angle = 35°\nArc = 2 × 35° = 70°\n\nThe intercepted arc is twice the inscribed angle.'
      },
      {
        id: 10,
        question: 'Two secants from an external point intersect a circle. If the external segment of one secant is 4 and its internal segment is 6, and the external segment of the other is 5, what is its internal segment?',
        options: ['3', '4', '5', '6'],
        correctAnswer: 0,
        solution: 'Secant-Secant Theorem:\n(external) × (whole) = (external) × (whole)\n\nFirst secant: 4 × (4 + 6) = 4 × 10 = 40\nSecond secant: 5 × (5 + x) = 40\n\n5(5 + x) = 40\n25 + 5x = 40\n5x = 15\nx = 3\n\nThe internal segment is 3.'
      },
      {
        id: 11,
        question: 'In a circle, a diameter is a special type of what?',
        options: ['Chord', 'Tangent', 'Secant', 'Arc'],
        correctAnswer: 0,
        solution: 'Diameter is the longest chord.\n\nDefinitions:\n• Chord: segment with both endpoints on circle\n• Diameter: chord passing through center\n• Tangent: line touching circle at one point\n• Secant: line intersecting circle at two points\n\nDiameter is a special chord through the center.'
      },
      {
        id: 12,
        question: 'If two chords are equidistant from the center of a circle, what can you conclude?',
        options: ['The chords are congruent', 'The chords are parallel', 'The chords are perpendicular', 'Nothing'],
        correctAnswer: 0,
        solution: 'Equidistant Chords Theorem:\nChords equidistant from the center are congruent.\n\nConverse: Congruent chords are equidistant from the center.\n\nEqual distance from center → equal chord lengths'
      },
      {
        id: 13,
        question: 'A tangent segment from point P to a circle has length 12. A secant from P has external segment 8. What is the length of the entire secant?',
        options: ['18', '16', '20', '24'],
        correctAnswer: 0,
        solution: 'Tangent-Secant Theorem:\n(tangent)² = (external) × (whole secant)\n\n12² = 8 × (whole)\n144 = 8 × whole\nwhole = 18\n\nThe entire secant is 18.'
      },
      {
        id: 14,
        question: 'What is the measure of the angle formed by two tangents drawn from an external point if the minor arc between the points of tangency is 100°?',
        options: ['80°', '100°', '50°', '200°'],
        correctAnswer: 0,
        solution: 'Angle formed by two tangents:\nAngle = 180° - minor arc\n\nMinor arc = 100°\nAngle = 180° - 100° = 80°\n\nAlternatively: Angle = (major arc - minor arc) ÷ 2\n= (260° - 100°) ÷ 2 = 160° ÷ 2 = 80°'
      },
      {
        id: 15,
        question: 'In a circle with radius 13, a chord has length 24. How far is the chord from the center?',
        options: ['5', '10', '12', '7'],
        correctAnswer: 0,
        solution: 'Perpendicular from center bisects chord.\n\nHalf-chord = 24 ÷ 2 = 12\n\nRight triangle:\n- Radius: 13\n- Half-chord: 12\n- Distance: d\n\nd² + 12² = 13²\nd² + 144 = 169\nd² = 25\nd = 5\n\nDistance from center = 5'
      },
      {
        id: 16,
        question: 'Two inscribed angles intercept the same arc. What is true about the angles?',
        options: ['They are congruent', 'They are supplementary', 'They are complementary', 'No relationship'],
        correctAnswer: 0,
        solution: 'Inscribed Angles Intercepting Same Arc Theorem:\nInscribed angles that intercept the same arc are congruent.\n\nBoth angles = (arc measure) ÷ 2\n\nSince they intercept the same arc, they have equal measures.'
      },
      {
        id: 17,
        question: 'A central angle and an inscribed angle intercept the same arc of 80°. What is the sum of the two angles?',
        options: ['120°', '80°', '160°', '40°'],
        correctAnswer: 0,
        solution: 'Arc = 80°\n\nCentral angle = arc = 80°\nInscribed angle = arc ÷ 2 = 40°\n\nSum = 80° + 40° = 120°'
      },
      {
        id: 18,
        question: 'What is the equation of a circle with center (3, -2) and radius 5?',
        options: ['(x - 3)² + (y + 2)² = 25', '(x + 3)² + (y - 2)² = 25', '(x - 3)² + (y + 2)² = 5', '(x + 3)² + (y - 2)² = 5'],
        correctAnswer: 0,
        solution: 'Circle equation: (x - h)² + (y - k)² = r²\n\nCenter: (h, k) = (3, -2)\nRadius: r = 5\n\n(x - 3)² + (y - (-2))² = 5²\n(x - 3)² + (y + 2)² = 25\n\nNote: Subtract the center coordinates, square the radius.'
      },
      {
        id: 19,
        question: 'An angle formed by a tangent and a chord at the point of tangency intercepts an arc of 110°. What is the measure of the angle?',
        options: ['55°', '110°', '70°', '220°'],
        correctAnswer: 0,
        solution: 'Tangent-Chord Angle Theorem:\nThe angle formed by a tangent and a chord is half the intercepted arc.\n\nArc = 110°\nAngle = 110° ÷ 2 = 55°\n\nThis is similar to the inscribed angle theorem.'
      },
      {
        id: 20,
        question: 'In a circle, if a radius is 10 and a chord is 16, what is the distance from the center to the chord?',
        options: ['6', '8', '10', '12'],
        correctAnswer: 0,
        solution: 'Perpendicular from center bisects chord.\n\nHalf-chord = 16 ÷ 2 = 8\n\nRight triangle:\n- Radius: 10\n- Half-chord: 8\n- Distance: d\n\nd² + 8² = 10²\nd² + 64 = 100\nd² = 36\nd = 6\n\nDistance = 6'
      },
      {
        id: 21,
        question: 'What is the measure of an angle formed by two chords intersecting inside a circle if the intercepted arcs are 60° and 80°?',
        options: ['70°', '140°', '20°', '60°'],
        correctAnswer: 0,
        solution: 'Angle Formed by Intersecting Chords:\nAngle = (sum of intercepted arcs) ÷ 2\n\nArcs: 60° and 80°\nAngle = (60° + 80°) ÷ 2 = 140° ÷ 2 = 70°\n\nThe angle is the average of the two arcs.'
      },
      {
        id: 22,
        question: 'A circle has center O and radius 8. Point P is 10 units from O. What is the length of the tangent from P to the circle?',
        options: ['6', '8', '10', '2'],
        correctAnswer: 0,
        solution: 'Right triangle formed by:\n- Radius to tangent point: 8\n- Distance from center to external point: 10\n- Tangent segment: t\n\nt² + 8² = 10²\nt² + 64 = 100\nt² = 36\nt = 6\n\nTangent length = 6'
      },
      {
        id: 23,
        question: 'If an inscribed quadrilateral has angles 80°, 100°, x, and y, what is x + y?',
        options: ['180°', '360°', '90°', '270°'],
        correctAnswer: 0,
        solution: 'Inscribed Quadrilateral Theorem:\nOpposite angles of an inscribed quadrilateral are supplementary.\n\n80° + x = 180° → x = 100°\n100° + y = 180° → y = 80°\n\nx + y = 100° + 80° = 180°\n\nOpposite angles sum to 180°.'
      },
      {
        id: 24,
        question: 'What is the length of an arc with central angle 90° in a circle with radius 12?',
        options: ['6π', '3π', '12π', '24π'],
        correctAnswer: 0,
        solution: 'Arc length formula: s = rθ (θ in radians)\n\n90° = π/2 radians\n\ns = 12 × (π/2) = 6π\n\nAlternatively: Arc = (90°/360°) × 2πr = (1/4) × 24π = 6π'
      },
      {
        id: 25,
        question: 'Two secants intersect outside a circle. If the intercepted arcs are 40° and 120°, what is the angle formed?',
        options: ['40°', '80°', '60°', '160°'],
        correctAnswer: 0,
        solution: 'Angle Formed by Two Secants (External):\nAngle = (difference of intercepted arcs) ÷ 2\n\nArcs: 120° and 40°\nAngle = (120° - 40°) ÷ 2 = 80° ÷ 2 = 40°\n\nThe angle is half the difference of the arcs.'
      },
      {
        id: 26,
        question: 'In a circle, a diameter perpendicular to a chord does what to the chord?',
        options: ['Bisects it', 'Doubles it', 'Trisects it', 'Nothing special'],
        correctAnswer: 0,
        solution: 'Perpendicular Diameter-Chord Theorem:\nA diameter (or radius) perpendicular to a chord bisects the chord.\n\nAlso bisects the arc intercepted by the chord.\n\nThis is a fundamental property used in many circle problems.'
      },
      {
        id: 27,
        question: 'What is the area of a sector with central angle 60° in a circle with radius 6?',
        options: ['6π', '3π', '12π', '36π'],
        correctAnswer: 0,
        solution: 'Sector area formula: A = (θ/360°) × πr²\n\nA = (60°/360°) × π(6²)\nA = (1/6) × 36π\nA = 6π\n\nThe sector is 1/6 of the circle.'
      },
      {
        id: 28,
        question: 'If a tangent and a secant are drawn from the same external point, and the tangent is 8 and the external part of the secant is 4, what is the internal part of the secant?',
        options: ['12', '16', '8', '4'],
        correctAnswer: 0,
        solution: 'Tangent-Secant Theorem:\n(tangent)² = (external) × (whole secant)\n\n8² = 4 × (whole)\n64 = 4 × whole\nwhole = 16\n\nInternal part = whole - external = 16 - 4 = 12'
      },
      {
        id: 29,
        question: 'What is the measure of a major arc if the minor arc is 100°?',
        options: ['260°', '100°', '180°', '360°'],
        correctAnswer: 0,
        solution: 'Minor arc + Major arc = 360°\n\nMinor arc = 100°\nMajor arc = 360° - 100° = 260°\n\nThe two arcs together form the complete circle.'
      },
      {
        id: 30,
        question: 'In a circle with center O, if ∠AOB = 80° (central angle), what is the measure of ∠ACB where C is on the major arc AB?',
        options: ['40°', '80°', '140°', '160°'],
        correctAnswer: 0,
        solution: 'Central angle ∠AOB = 80° intercepts minor arc AB = 80°\n\nInscribed angle ∠ACB on major arc intercepts the same minor arc AB.\n\nInscribed angle = arc ÷ 2 = 80° ÷ 2 = 40°\n\n∠ACB = 40°'
      }
    ]
  }
];